import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'timetable',
  initialState: {
    items: [],
    selectedId : 0 
  },
  reducers: {

    setItems(state, action) {
      state.items = action.payload;
    },

  },
});

export { actions as timetableActions };
export { reducer as timetableReducer };
